import axios from 'axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/styles/vendors.min.css'

const app = createApp(App)

app.use(router)
app.mount('#app')

axios.defaults.baseURL = 'https://rest.epatim.kayrem.com/api/' // prod
axios.defaults.withCredentials = true
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'

// Bu endpoint(ler) için Authorization ekleme
const AUTH_EXCLUDE_PATHS = ['token/refresh/', 'token/']

axios.interceptors.request.use(
    config => {
        const url = config?.url || ''
        const isExcluded = AUTH_EXCLUDE_PATHS.some(p => url.includes(p))

        if (!isExcluded) {
            const token = localStorage.getItem('access')
            if (token) config.headers.Authorization = `Bearer ${token}`
        } else if (config.headers?.Authorization) {
            // güvenlik: refresh isteğinde yanlışlıkla kalmışsa temizle
            delete config.headers.Authorization
        }

        return config
    },
    error => Promise.reject(error)
)

axios.interceptors.response.use(
    response => response,
    async error => {
        const original = error.config

        // Sonsuz döngüyü engelle
        if ((error.response?.status === 401 || error.response?.status === 403) && !original?._retry) {
            original._retry = true

            try {
                const refresh = localStorage.getItem('refresh')
                if (!refresh) throw new Error('No refresh token')

                // Refresh çağrısını Authorization olmadan yap
                const refreshResponse = await axios.post('token/refresh/', { refresh }, { headers: {} })

                localStorage.setItem('access', refreshResponse.data.access)

                original.headers = original.headers || {}
                original.headers.Authorization = `Bearer ${refreshResponse.data.access}`
                return axios(original)
            } catch (refreshError) {
                localStorage.removeItem('access')
                localStorage.removeItem('refresh')
                localStorage.removeItem('user')
                window.location.href = '/login'
                return Promise.reject(refreshError)
            }
        }

        return Promise.reject(error)
    }
)

app.config.globalProperties.$axios = axios




